// extracted by mini-css-extract-plugin
export default {"read_more":"ReadMore_read_more__gIYHM","read_more_container":"ReadMore_read_more_container__uhGEE","description":"ReadMore_description__4hjG8"};